import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=1a5de022&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a5de022')) {
      api.createRecord('1a5de022', component.options)
    } else {
      api.reload('1a5de022', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=1a5de022&", function () {
      api.rerender('1a5de022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28dI46vaWZtYc/JS/comp/ImgFallback2.vue"
export default component.exports